import type { CartItem } from "../../../model/product.cart.model";
import { FreightType } from "../../../model/customer.model";

import { subtotalApplyTaxAccordingFreight } from "../../../domain/calculations/subtotalApplyTaxAccordingFreight";

export function recalcCartTotalsByFreight(args: {
  cart: CartItem[];
  freightType: FreightType;
}): CartItem[] {
  const { cart, freightType } = args;

  return cart.map((it) => {
    const subtotal = subtotalApplyTaxAccordingFreight(
      it.quantity,
      freightType,
      it.unitPrice,
      it.freightUnitPrice
    );
    const total = subtotal;
    return { ...it, subtotal, total };
  });
}
